import { Controller } from '@libs/ui/form'
import { usePlanningFormTranslation } from '@libs/utils/translations'
import { formatErrors } from '@spa/components/FormFields/helpers'
import type { FC } from 'react'
import { useFormContext } from 'react-hook-form'

import type { RestFormData } from '../../../hooks'

export const AccidentDate: FC = () => {
  const { t } = usePlanningFormTranslation()

  const {
    control,
    formState: { errors }
  } = useFormContext<RestFormData>()

  return (
    <Controller.DatePickerInput
      label={t('restForm.dateOfAccident')}
      name='accident_date'
      control={control}
      errorMessage={formatErrors({
        inputName: 'accident_date',
        errors
      })}
    />
  )
}
